export const normalizeQuantityInput = (rawValue) => {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 0
  }

  const parsed = parseInt(rawValue, 10)

  if (isNaN(parsed) || parsed < 0) {
    return 0
  }

  return parsed
}

export const clampQuantity = (value, min = 0, max = Number.POSITIVE_INFINITY) => {
  const normalized = normalizeQuantityInput(value)

  if (normalized < min) {
    return min
  }

  if (Number.isFinite(max) && normalized > max) {
    return max
  }

  return normalized
}
